module.exports = __webpack_public_path__ + "static/media/02_minatoe504ea0970decddb99d5604c39b69cc4.webp";